import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHConvenioIns = async (credentials, data) => {
  const body = {
    service: "RNHConvenioIns",
    params: {
      rnhConvenioCod: data?.cod || null,
      rnhConvenioLey: data?.ley || null,
      // A string: el back espera el numero como texto.
      rnhConvenioCargaSemanal:
        data?.cargaSemanal != null ? String(data.cargaSemanal) : null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
